// Centralized storage keys for auth and user data
export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'access-token',
  REFRESH_TOKEN: 'refresh-token',
  USER: 'user',
  TOKEN: 'token',
  USER_DETAILS: 'userDetails',
  CART: 'cart',
  CART_BOOK: 'cartBook',
  LOGIN_TIMESTAMP: 'loginTimestamp',
  ACTIVE_TAB: 'activeTab',
  ACTIVE_MANAGE_TAB: 'activeManageTab',
  PDF_GENERATION_STATES: 'pdfGenerationStates',
  PDF_NOTIFICATIONS: 'pdfNotifications',
  PDF_URLS: 'pdfUrls',
  GUEST_CART: 'guest_cart',
  CLICKED_ADD_CART: 'clickedAddCart',
  BUY_VOUCHER_REDIRECT: 'buyVoucherRedirect',
};

export const BASE_URL = process.env.REACT_APP_API_URL || "";

export const shouldDisableInspect = process.env.REACT_APP_DISABLE_INSPECT === "true";

export const UtcOffsetInSecond = "19800";

export const AppVersion = "1";

export const workerUrl = `https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`

export const FacebookURL = "https://www.facebook.com/memorised.books"

export const InstagramURL = "https://www.instagram.com/memorised.books"

export const PinterestURL = "https://www.pinterest.com/memorised_books"

export const TikTokURL = "https://www.tiktok.com/@memorised.books"

export const LIVE_SITE_URL = "https://memorised.com.au"

export const GENERATE_SITEMAP=true

export const NO_INDEX=false  //if this flag is false means site will show in search results